import(/* webpackMode: "eager" */ "/codebuild/output/src2521049689/src/apps/web/app/[locale]/error.tsx");
